import { useState } from "react";
import { ChevronRight } from "lucide-react";
import { Brand } from "../components/Brand";
import { Toast } from "../components/Toast";
import { Spinner } from "../components/Loader";
import { authService } from "../services/authService";
import loginBg from "../assets/login_bg.png";

export function Login({ onLogin, notify, toast }) {
  const [form, setForm] = useState({ contact: "admin", password: "admin123" });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function submit(event) {
    event.preventDefault();
    if (submitting) return;
    setError("");
    setSubmitting(true);
    try {
      const result = await authService.login(form);
      onLogin(result);
    } catch (err) {
      const message = err?.message || "Login failed. Please try again.";
      setError(message);
      notify(message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login-page" style={{ backgroundImage: `url(${loginBg})` }}>
      <section className="login-panel">
        <Brand large />
        {/* <h1>Run bookings, rooms, staff, and reports from one secure workspace.</h1> */}
        <form onSubmit={submit} className="form-stack" aria-busy={submitting || undefined}>
          <label>Contact / Username<input disabled={submitting} placeholder="Enter contact or username" value={form.contact} onChange={(event) => setForm({ ...form, contact: event.target.value })} /></label>
          <label>Password<input disabled={submitting} type="password" placeholder="Enter password" value={form.password} onChange={(event) => setForm({ ...form, password: event.target.value })} /></label>
          <button className="primary" disabled={submitting} type="submit">
            {submitting && <Spinner size={15} />}
            {submitting ? "Signing in..." : "Sign in"}
            {!submitting && <ChevronRight size={17} />}
          </button>
          {error && <p className="login-error">{error}</p>}
        </form>
      </section>
      <Toast message={toast} />
    </div>
  );
}
